// extracted by mini-css-extract-plugin
module.exports = {"heading_text":"heading_heading_text__2gBAP"};